module.exports = __webpack_public_path__ + "static/media/pointer.8c74f83c.webp";